import axios from "axios";
import Swal from "sweetalert2";
import { tokenConfig } from "./websiteActions";
import { t } from "i18next";

const getListByShop =
    (shopId, setIsLoading) =>
        (dispatch, getState) => {
            setIsLoading(true)
            return axios
                .get(
                    `/api/coupon-tiktok/list-by-shop?shopId=${shopId}`,
                    tokenConfig(getState)
                )
                .then((res) => {
                    if (res.data.status === 200) {
                        setIsLoading(false)
                        return res.data.data.listcoupon;
                    }
                    return [];
                })
                .catch((err) => {
                    return [];
                });
        };

const syncCouponTiktok = (shopId, setIsLoading) => async (dispatch, getState) => {
    return Swal.fire({
        title: t("Are you sure?"),
        text: t("Are you sure to sync coupons?"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: t("Sure"),
        cancelButtonText: t("Cancel"),
    }).then(async (result) => {
        if (result.value) {
            setIsLoading(true)
            return await axios
                .get(`/api/coupon-tiktok/sync-by-shop?shopId=${shopId}`, tokenConfig(getState))
                .then((res) => {
                    if (res.data.status === 200) {
                        setIsLoading(false)
                        Swal.fire(t("Success"), t(res.data.message), "success");
                        return res.data.data.listcoupon;
                    } else {
                        setIsLoading(false)
                        Swal.fire(t("Error"), t(res.data.message), "error");
                        return [];
                    }
                })
                .catch((err) => {
                    setIsLoading(false)
                    Swal.fire(t("Error"), t("An error occurred!"), "error");
                    return [];
                });
        }
    });
};
const setAutoCouponTiktok = (shopId, couponId, auto_coupon, setIsLoading) => async (dispatch, getState) => {
    return Swal.fire({
        title: t("Are you sure?"),
        text: t("Are you sure set auto coupons?"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: t("Sure"),
        cancelButtonText: t("Cancel"),
    }).then(async (result) => {
        if (result.value) {
            setIsLoading(true)
            return await axios
                .get(`/api/coupon-tiktok/auto-by-shop?shopId=${shopId}&couponId=${couponId}&auto_coupon=${auto_coupon}`, tokenConfig(getState))
                .then((res) => {
                    if (res.data.status === 200) {
                        setIsLoading(false)
                        Swal.fire(t("Success"), t(res.data.message), "success");
                        return res.data.data.listcoupon;
                    } else {
                        setIsLoading(false)
                        Swal.fire(t("Error"), t(res.data.message), "error");
                        return [];
                    }
                })
                .catch((err) => {
                    setIsLoading(false)
                    Swal.fire(t("Error"), t("An error occurred!"), "error");
                    return [];
                });
        }
    });
};

export { getListByShop, syncCouponTiktok, setAutoCouponTiktok };
